import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ActivityFeedItem = ({ activity, onViewDetails }) => {

  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed':
        return 'CheckCircle';
      case 'failed':
        return 'XCircle';
      case 'partial':
        return 'AlertTriangle';
      case 'in_progress':
        return 'RefreshCw';
      default:
        return 'Clock';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'text-success';
      case 'failed':
        return 'text-error';
      case 'partial':
        return 'text-warning';
      case 'in_progress':
        return 'text-primary';
      default:
        return 'text-text-muted';
    }
  };


  const formatTimestamp = (date) => {
    const now = new Date();
    const diff = now - date;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    if (days < 7) return `${days}d ago`;
    return date.toLocaleDateString();
  };

  const sourcePlatformIcon = (sourcePlatform) => {
    switch (sourcePlatform) {
      case "youtube":
          return <Icon name="Play" size={12} className="text-error" />
      case "spotify":
          return  <Icon name="Music" size={12} className="text-success" />
      default:
        break;
    }
  }

  const destinationPlatformIcon = (destinationPlatform) => {
    switch (destinationPlatform) {
      case "youtube":
          return <Icon name="Play" size={12} className="text-error" />
      case "spotify":
          return  <Icon name="Music" size={12} className="text-success" />
      default:
        break;
    }
  }


  return (
    <div className="bg-surface border border-border rounded-lg p-4 shadow-elevation-1 hover:shadow-elevation-2 transition-smooth">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center space-x-3">
          <div className={`flex items-center justify-center w-10 h-10 rounded-lg ${
            activity.status === 'completed' ? 'bg-success/10' :
            activity.status === 'failed' ? 'bg-error/10' :
            activity.status === 'partial'? 'bg-warning/10' : 'bg-primary/10'
          }`}>
            <Icon 
              name={getStatusIcon(activity.status)} 
              size={20} 
              className={getStatusColor(activity.status)}
            />
          </div>
          
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-medium text-text-primary truncate">
              {activity.playlistName}
            </h4>
            <div className="flex items-center space-x-2 mt-1">
              <div className="flex items-center space-x-1">
              {sourcePlatformIcon(activity.sourcePlatform)}
                <Icon name="ArrowRight" size={12} className="text-text-muted" />
                {destinationPlatformIcon(activity.destinationPlatform)}
              </div>
              <span className="text-xs text-text-secondary">
                {activity.songsTransferred}/{activity.totalSongs} songs
              </span>
            </div>
          </div>
        </div>

        <div className="text-right">
          <span className="text-xs text-text-muted">
            {formatTimestamp(activity.timestamp)}
          </span>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="text-xs">
            <span className={`font-medium ${getStatusColor(activity.status)}`}>
              {activity.status.charAt(0).toUpperCase() + activity.status.slice(1).replace('_', ' ')}
            </span>
          </div>
          
          {activity.status === 'completed' && (
            <div className="text-xs text-text-secondary">
              Duration: {activity.duration}
            </div>
          )}
        </div>

        {/* <Button
          variant="ghost"
          size="sm"
          onClick={() => onViewDetails(activity.id)}
          iconName="ExternalLink"
          iconSize={14}
        >
          Details
        </Button> */}
      </div>

      {activity.status === 'in_progress' && (
        <div className="mt-3">
          <div className="flex items-center justify-between text-xs text-text-secondary mb-1">
            <span>Progress</span>
            <span>{Math.round((activity.songsTransferred / activity.totalSongs) * 100)}%</span>
          </div>
          <div className="w-full bg-surface-secondary rounded-full h-2">
            <div 
              className="bg-primary h-2 rounded-full transition-all duration-300"
              style={{ width: `${(activity.songsTransferred / activity.totalSongs) * 100}%` }}
            ></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ActivityFeedItem;